import axios from 'axios';

import {
  DataTransferRequest,
  DataTransferRestoreRequest,
  GetDataOperationsParams
} from 'types/dto/data-operation.dto';
import DataOperation from 'types/models/data-operation';
import { APIResponseParsed } from 'types/response';
import { getRequest, postRequest } from 'utils/HttpRequest/http-request-utils';

import { parseAxiosError } from './utils/parse-axios-error';

// ==============================
// REQUESTS
// ==============================
async function createDataTransfer(
  request: DataTransferRequest
): Promise<APIResponseParsed<DataOperation>> {
  try {
    const response = await postRequest<DataOperation, DataTransferRequest>(
      '/data-operation/data-transfer',
      request
    );
    return { data: response.data, error: null };
  } catch (error) {
    if (!axios.isAxiosError(error)) throw error;
    return { data: null, error: parseAxiosError(error) };
  }
}

async function restoreDataTransfer(
  request: DataTransferRestoreRequest
): Promise<APIResponseParsed<DataOperation>> {
  try {
    const response = await postRequest<DataOperation, DataTransferRestoreRequest>(
      '/data-operation/data-transfer-restore',
      request
    );
    return { data: response.data, error: null };
  } catch (error) {
    if (!axios.isAxiosError(error)) throw error;
    return { data: null, error: parseAxiosError(error) };
  }
}

async function fetchDataOperations(
  params?: GetDataOperationsParams
): Promise<APIResponseParsed<DataOperation[]>> {
  try {
    const response = await getRequest<DataOperation[]>('/data-operation', { params });
    return { data: response.data, error: null };
  } catch (error) {
    if (!axios.isAxiosError(error)) throw error;
    return { data: null, error: parseAxiosError(error) };
  }
}

export default {
  createDataTransfer,
  restoreDataTransfer,
  fetchDataOperations
};
